import { Image, Text, View } from "@react-pdf/renderer";

import { styles } from "../../Tables";

export const TableRowCIPPEvdListaDefinisanihTacakaHeader: React.FC<{
  datum: string;
  fullname: string;
  potpis: string;
}> = ({ datum, fullname, potpis }) => (
  <View style={styles.tableRow}>
    <View style={styles.tableCol}>
      <Text>{datum}</Text>
    </View>
    <View style={styles.tableCol}>
      <Text>{fullname}</Text>
    </View>
    <View style={styles.tableCol}>
      <Text>{potpis}</Text>
    </View>
  </View>
);

export const TableRowCIPPEvdListaDefinisanihTacaka: React.FC<{
  datum: string;
  fullname: string;
  potpis: string;
}> = ({ datum, fullname, potpis }) => (
  <View style={styles.tableRow} wrap={false}>
    <View style={styles.tableCol}>
      <Text style={styles.tableCell}>{datum}</Text>
    </View>
    <View style={styles.tableCol}>
      <Text style={styles.tableCell}>{fullname}</Text>
    </View>
    <View style={styles.tableCol}>
      {potpis && (
        <Image style={[styles.tableCell, styles.signatureImage]} src={potpis} />
      )}
    </View>
  </View>
);
